__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-10-1783669912-stable-dev/";